import { render, staticRenderFns } from "./configDetail.vue?vue&type=template&id=1d0256a4&scoped=true&"
import script from "./configDetail.vue?vue&type=script&lang=js&"
export * from "./configDetail.vue?vue&type=script&lang=js&"
import style0 from "./configDetail.vue?vue&type=style&index=0&id=1d0256a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0256a4",
  null
  
)

export default component.exports